import type { ReactElement } from 'react';
import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import type { BaseOrganisation } from 'services/assist-api/entities/customers/customers';
import FiltersAndTable from './filters-and-table';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onRequestRefetch: () => void;
  selectedResponseIds: number[];
  currentOrganisation: BaseOrganisation;
};

export default function AllocateResponsesModal({
  isOpen,
  onClose,
  onRequestRefetch,
  selectedResponseIds,
  currentOrganisation
}: Props): ReactElement {
  return (
    <Modal isOpen={isOpen} size="xl">
      <ModalHeader toggle={onClose}>Allocate Responses</ModalHeader>
      <ModalBody>
        <div>
          <p>
            <strong>Responses:</strong> {selectedResponseIds.join(', ')}
          </p>
          <p>Select the markers that you would like to allocate to these responses.</p>
          <FiltersAndTable
            selectedResponseIds={selectedResponseIds}
            currentOrganisation={currentOrganisation}
            onClose={onClose}
            onRequestRefetch={onRequestRefetch}
          />
        </div>
      </ModalBody>
    </Modal>
  );
}
